import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import HintContainer from '../../containers/hints/hint-container';
import OrdersFiltersContainer from '../../containers/orders-filters-container';
import UserOrdersContainer from '../../containers/user-orders-container';
import AppPageMain from '../../modules/app-page/app-page--main';
import PageHeader from '../../modules/page-header';
import { RootState } from '../../types';

const Orders: FC = () => {
  const isVisibleHint = useSelector((state: RootState) =>
    state.auth.profile.introHints.includes('ORDER_INTRO')
  );

  return (
    <AppPageMain>
      <div className="container">
        <div className="row">
          <div className="col-19S col-lg-27 col-xl-35">
            <PageHeader
              items={[{ link: '', title: 'Реестр' }]}
              iconType="order"
            />
          </div>
        </div>

        {isVisibleHint ? (
          <HintContainer hint="ORDER_INTRO" />
        ) : (
          <>
            <div className="row">
              <div className="col-19 col-lg-27 col-xl-35">
                <OrdersFiltersContainer />
              </div>
            </div>
            <div className="row">
              <div className="col-19 col-lg-27 col-xl-35">
                <UserOrdersContainer />
              </div>
            </div>
          </>
        )}
      </div>
    </AppPageMain>
  );
};

export default Orders;
